import { render } from "./LinkageSignupConfirm.vue?vue&type=template&id=0c10090a&scoped=true&ts=true"
import script from "./LinkageSignupConfirm.vue?vue&type=script&lang=ts"
export * from "./LinkageSignupConfirm.vue?vue&type=script&lang=ts"

import "./LinkageSignupConfirm.vue?vue&type=style&index=0&id=0c10090a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c10090a"]])

export default __exports__